import { useLocation } from 'react-router';

export function useBaseMessageUrl() {
  const location = useLocation();
  const baseUrl = location.pathname.replace(/\/messages(\/[0-9a-zA-Z\-\:\_]*)*$/, '');

  return baseUrl;
}
